export default __webpack_public_path__ + "static/media/portfolioHero.bd16fbc2.png";